import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import { EquipmentNavBar } from "../../components/Equipments/EquipmentNavBar";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import { EquipmentUtilities } from "../../EquipmentUtilities";
import { EquipmentDTO } from "../../models/Equipment/EquipmentDTO";

export default function EquipamentEdit() {
  const [pageTitle, setPageTitle] = useState("Equipamento");
  const [equipment, setEquipment] = useState<EquipmentDTO | null>(null);
  const [isFetchingEquipmentData, setIsFetchingEquipmentData] = useState<boolean>(false);

  const MainContent = useDynamicComponent("EquipmentEdit", { setPageTitle, equipment, setEquipment, isFetchingEquipmentData });

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    setIsFetchingEquipmentData(true);
    const fetchEquipment = async () => {
      if (id) {
        const equipmentData = await EquipmentUtilities.GetEquipment(id);
        if (equipmentData) {
          setEquipment(equipmentData);
          setIsFetchingEquipmentData(false);
        }
      }
      setIsFetchingEquipmentData(false);
    };

    fetchEquipment();
  }, [id]);

  return (
    <Layout>
      <div className="pageContainer">
        <div
          className="pageHeader"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PageTitle title={pageTitle} allowGoBack={true} />
          <div
            style={{
              marginLeft: "auto",
            }}
          ></div>
        </div>
        <div className="pageBody">
          <Row>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              {MainContent}
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              <EquipmentNavBar equipment={equipment} />
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
}